import React from 'react';
import { Link } from 'react-router-dom';
import {
  IconBolt,
  IconMessageCircle,
  IconSend
} from '@tabler/icons-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-10 sm:py-16 border-t border-gray-300 dark:border-dark-850 bg-white dark:bg-dark-950/50 transition-colors duration-300">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Бренд */}
          <div className="col-span-2 sm:col-span-2 md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-br from-primary-500 to-primary-400 rounded-lg flex items-center justify-center">
                <IconBolt className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-black" strokeWidth={2.5} />
              </div>
              <span className="font-bold text-lg sm:text-xl text-gray-900 dark:text-white">
                XN Connect
              </span>
            </Link>
            <p className="text-gray-600 dark:text-dark-600 text-xs sm:text-sm max-w-xs">
              Играй с друзьями без VPN и сложных настроек. Просто работает.
            </p>
          </div>

          {/* Продукт */}
          <div>
            <div className="text-xs font-semibold text-gray-700 dark:text-dark-500 uppercase tracking-wider mb-5">
              Продукт
            </div>
            <ul className="space-y-3">
              <li>
                <Link to="/download" className="text-gray-600 dark:text-dark-600 text-sm hover:text-primary-500 transition-colors">
                  Скачать
                </Link>
              </li>
              <li>
                <Link to="/subscribe" className="text-gray-600 dark:text-dark-600 text-sm hover:text-primary-500 transition-colors">
                  Подписка
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-gray-600 dark:text-dark-600 text-sm hover:text-primary-500 transition-colors">
                  Панель
                </Link>
              </li>
            </ul>
          </div>

          {/* Поддержка */}
          <div>
            <div className="text-xs font-semibold text-gray-700 dark:text-dark-500 uppercase tracking-wider mb-5">
              Юридическое
            </div>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-gray-600 dark:text-dark-600 text-sm hover:text-primary-500 transition-colors">
                  Конфиденциальность
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 dark:text-dark-600 text-sm hover:text-primary-500 transition-colors">
                  Условия
                </Link>
              </li>
              <li>
                <a
                  href="https://t.me/XNCsup_bot"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-600 dark:text-dark-600 text-sm hover:text-primary-500 transition-colors"
                >
                  <IconSend className="w-4 h-4" />
                  Telegram бот
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Нижняя часть */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-300 dark:border-dark-850">
          <p className="text-gray-600 dark:text-dark-600 text-sm">
            © {currentYear} XN Connect. Все права защищены.
          </p>
          <div className="flex gap-4 mt-3 md:mt-0">
            <Link to="/privacy" className="text-gray-600 dark:text-dark-600 text-xs hover:text-primary-500 transition-colors">
              Политика конфиденциальности
            </Link>
            <Link to="/terms" className="text-gray-600 dark:text-dark-600 text-xs hover:text-primary-500 transition-colors">
              Условия использования
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
